import React from "react"
import { StaticQuery, graphql, Link } from "gatsby"

import styles from "./categories.module.scss"

const Categories = props => (
  <StaticQuery
    query={graphql`
      {
        allSanityCategory(sort: { order: ASC, fields: order }) {
          edges {
            node {
              slug {
                current
              }
              title
              _id
              colorPalette {
                color
              }
            }
          }
        }
        allSanityTypeCategory(sort: { order: ASC, fields: slug___current }) {
          edges {
            node {
              slug {
                current
              }
              title
              _id
              colorPalette {
                color
              }
            }
          }
        }
        allSanitySectorCategory(sort: { order: ASC, fields: slug___current }) {
          edges {
            node {
              parentCat
              slug {
                current
              }
              title
              _id
              colorPalette {
                color
              }
            }
          }
        }
      }
    `}
    render={data => {
      const setCatList = type => {
        if (type === "blog") {
          return data.allSanityCategory.edges
        } else if (type === "resources") {
          return data.allSanityTypeCategory.edges
        } else if (type === "case-studies") {
          return data.allSanitySectorCategory.edges
        }
      }
      const cats = setCatList(props.postType)
      const industryCats = cats.filter(cat => cat.node.parentCat === "industry")
      const serviceCats = cats.filter(cat => cat.node.parentCat === "service")

      const sectorCatList = (
        <ul>
          <li>
            <h3 className={styles.parentCat}>Industry</h3>
            <ul>
              {industryCats.map(({ node: cat }) => (
                <li key={cat._id} data-theme={"categoryYellow"}>
                  <Link to={`/${props.postType}/${cat.slug.current}/`}>
                    {cat.title}
                  </Link>
                </li>
              ))}
            </ul>
          </li>
          {/* <li>
            <h3 className={styles.parentCat}>Service</h3>
            <ul>
              {serviceCats.map(({ node: cat }) => (
                <li key={cat._id} data-theme={"categoryYellow"}>
                  <Link to={`/${props.postType}/${cat.slug.current}/`}>
                    {cat.title}
                  </Link>
                </li>
              ))}
            </ul>
          </li> */}
        </ul>
      )
      return (
        <>
          <div className={styles.categories}>
            <h3>Filter Categories</h3>
            <Link className={styles.allLink} to={`/${props.postType}/`}>
              All
            </Link>
            {props.postType === "case-studies" ? (
              sectorCatList
            ) : (
              <ul>
                {cats.map(({ node: cat }) => (
                  <li
                    key={cat._id}
                    data-theme={cat.colorPalette?.color || "categoryYellow"}
                  >
                    <Link to={`/${props.postType}/${cat.slug.current}/`}>
                      {cat.title}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </>
      )
    }}
  />
)

export default Categories
